export const STATUS_META = {
  baru: { label: "Baru", cls: "bg-blue-100 text-blue-800" },
  diproses: { label: "Dikonfirmasi", cls: "bg-amber-100 text-amber-800" },
  dikirim: { label: "Dikirim", cls: "bg-purple-100 text-purple-800" },
  selesai: { label: "Selesai", cls: "bg-green-100 text-green-800" },
  dibatalkan: { label: "Dibatalkan", cls: "bg-red-100 text-red-800" },
};

export const PAYMENT_META = {
  belum_bayar: { label: "Belum Bayar", cls: "bg-red-100 text-red-800" },
  dp: { label: "DP", cls: "bg-amber-100 text-amber-800" },
  lunas: { label: "Lunas", cls: "bg-green-100 text-green-800" },
};

export const STATUS_OPTIONS = Object.keys(STATUS_META);
export const PAYMENT_OPTIONS = Object.keys(PAYMENT_META);

export function StatusBadge({ status }) {
  const m = STATUS_META[status] || STATUS_META.baru;
  return (
    <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold ${m.cls}`}>
      {m.label}
    </span>
  );
}

export function PaymentBadge({ status }) {
  const m = PAYMENT_META[status] || PAYMENT_META.belum_bayar;
  return (
    <span className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold ${m.cls}`}>
      {m.label}
    </span>
  );
}
